import script from "./ProfileList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileList.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileList.vue?vue&type=style&index=0&id=7608208c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7608208c"]])

export default __exports__